import React, { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

function DraggableQuestion({ question, type, index }) {
  const questionText = question.contents?.q?.en;

  return (
    <Draggable draggableId={String(question.id)} index={index}>
      {(provided) => {
        return (
          <div
            className="QM__draggable-question"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <p style={{ width: "5%", fontSize: "1.5rem" }}>{question.id + 1}.</p>{" "}
            <div className="QM__draggable-question-inner">
              <div className="QM__draggable-question-inner-top">
                <span>[{type}]</span>{" "}
                {question.type === "multipleChoice" && (
                  <span>
                    Answers:{" "}
                    <span
                      className={`QM__draggable-question-answer-count ${!question.contents?.a?.length ? "empty" : ""}`}
                    >
                      {question.contents?.a?.length || "0"}
                    </span>
                  </span>
                )}
                {question.type === "dragDropPair" && (
                  <span>
                    Pairs:{" "}
                    <span
                      className={`QM__draggable-question-answer-count ${!question.contents?.a?.length ? "empty" : ""}`}
                    >
                      {question.contents?.a?.length || "0"}
                    </span>
                  </span>
                )}
              </div>
              <p className={`question-preview ${!questionText ? "empty" : ""}`}>
                Q:{" "}
                {questionText ? (
                  <>&quot;{questionText?.replace(/<[^>]+>/g, "")}&quot;</>
                ) : (
                  <span className="QM__settings-invalid">(empty)</span>
                )}
              </p>
            </div>
          </div>
        );
      }}
    </Draggable>
  );
}

function QuestionClone({ question, type }) {
  const questionText = question.contents?.q?.en;

  return (
    <div className="QM__draggable-question" id="dragging">
      <p style={{ width: "5%", fontSize: "1.5rem" }}>{question.id + 1}.</p>{" "}
      <div className="QM__draggable-question-inner">
        <div className="QM__draggable-question-inner-top">
          <span>[{type}]</span>{" "}
          {question.type === "multipleChoice" && (
            <span>
              Answers:{" "}
              <span className={`QM__draggable-question-answer-count ${!question.contents?.a?.length ? "empty" : ""}`}>
                {question.contents?.a?.length || "0"}
              </span>
            </span>
          )}
          {question.type === "dragDropPair" && (
            <span>
              Pairs:{" "}
              <span className={`QM__draggable-question-answer-count ${!question.contents?.a?.length ? "empty" : ""}`}>
                {question.contents?.a?.length || "0"}
              </span>
            </span>
          )}
        </div>
        <p className={`question-preview ${!questionText ? "empty" : ""}`}>
          Q:{" "}
          {questionText ? (
            <>&quot;{questionText?.replace(/<[^>]+>/g, "")}&quot;</>
          ) : (
            <span className="QM__settings-invalid">(empty)</span>
          )}
        </p>
      </div>
    </div>
  );
}

function QuestionDragReorder({ questions, setQuestions }) {
  const [clone, setClone] = useState();

  function getQuestionType(text) {
    switch (text) {
      case "multipleChoice":
        return "Multiple choice";
      case "trueFalse":
        return "True / false";
      case "dragDropPair":
        return "Drag / drop pairs";
      case "sorting":
        return "Sorting";
      case "dragWords":
        return "Drag words";
      case "markWords":
        return "Mark words";
      case "shortAnswer":
        return "Short answer";
      default:
        return "unknown";
    }
  }

  function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    result.forEach((q, i) => (q.id = i)); // reorder IDs

    return result;
  }

  function handleDragStart(start) {
    setClone(questions[parseInt(start.draggableId)]);
  }

  function handleDragEnd(result) {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;

    const newQuestions = reorder(questions, result.source.index, result.destination.index);
    setQuestions(newQuestions);
  }

  return (
    <DragDropContext onBeforeDragStart={handleDragStart} onDragEnd={handleDragEnd}>
      <Droppable
        droppableId="list"
        renderClone={(provided) => {
          const type = getQuestionType(clone.type);
          return (
            <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
              <QuestionClone question={clone} type={type} />
            </div>
          );
        }}
      >
        {(provided) => {
          const style = { display: "flex", flexDirection: "column", width: "100%", ...provided.droppableProps.style };
          return (
            <div ref={provided.innerRef} {...provided.droppableProps} style={style}>
              {questions.map((q, i) => {
                const type = getQuestionType(q.type);
                return <DraggableQuestion key={i} question={q} type={type} index={i} />;
              })}
              {provided.placeholder}
            </div>
          );
        }}
      </Droppable>
    </DragDropContext>
  );
}

export default QuestionDragReorder;
